import React from 'react';
import { Box, Paper } from '@mui/material';
import { useAuthFlow } from '../hooks/useAuthFlow';
import { SignInForm } from './SignInForm';
import { ConfirmEmailMfaForm } from './ConfirmEmailMfaForm';
import { NewPasswordRequiredForm } from './NewPasswordRequiredForm';
import { WallpaperBackground } from './WallpaperBackground';
import { cardSx } from './authFormStyles';

interface Props {
  onSuccess: () => void;
}

export const LoginScreen: React.FC<Props> = ({ onSuccess }) => {
  const {
    step,
    loading,
    error,
    codeDeliveryDestination,
    signIn,
    confirmCode,
    confirmNewPassword,
  } = useAuthFlow(onSuccess);

  return (
    <Box
      component="div"
      sx={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        p: 2,
        position: 'relative',
      }}
    >
      <WallpaperBackground />
      <Paper elevation={0} sx={cardSx}>
        {step === 'SIGN_IN' && (
          <SignInForm onSubmit={signIn} loading={loading} error={error} />
        )}
        {step === 'CONFIRM_EMAIL_CODE' && (
          <ConfirmEmailMfaForm
            onSubmit={confirmCode}
            loading={loading}
            error={error}
            codeDeliveryDestination={codeDeliveryDestination}
          />
        )}
        {step === 'NEW_PASSWORD_REQUIRED' && (
          <NewPasswordRequiredForm
            onSubmit={confirmNewPassword}
            loading={loading}
            error={error}
          />
        )}
      </Paper>
    </Box>
  );
};
